import TextColorButton from './ColorButton';
import decorateComponentWithProps from 'decorate-component-with-props';
export default (function (_a) {
    var customStylesPlugin = _a.customStylesPlugin;
    return ({
        TextButtonMapper: function () {
            return {
                TextToolsColor: {
                    component: decorateComponentWithProps(TextColorButton, {
                        customStylesPlugin: customStylesPlugin,
                    }),
                    isMobile: true,
                    position: {
                        mobile: 7,
                    },
                },
            };
        },
    });
});
//# sourceMappingURL=createTextToolsToolbar.js.map